import { HttpError } from "react-admin";

import { errorMessages, settings } from "app";
import { refreshToken } from "core/dataProvider.utils";

import { LEGACY, MIXED, PASCAL } from "./dataProvider.types";
import { getOptions } from "./dataProvider.getOptions";

export const logMethod = (method, url) => {
  // console.log(`dataProvider.${method}: ${url}`);
};

export const getProviderType = params => {
  let result = MIXED;

  if (!!params?.meta?.legacy_provider) {
    return LEGACY;
  }

  if (!!params?.meta?.mixed_provider) {
    return MIXED;
  }
  if (!!params?.meta?.pascal_provider) {
    return PASCAL;
  }
  if (settings.dataProviderVersion) {
    return settings.dataProviderVersion;
  }

  return result;
};

export const getListData = ({ response, params }) => {
  let data;
  let totalItems;

  switch (getProviderType(params)) {
    case LEGACY:
      data = response.json;
      totalItems = parseInt(response.headers.get("x-total-count"));
      break;
    case MIXED:
      data = response.json.items || response.json;
      totalItems = response.json.total_items || response.json.totalItems || response.json.length;
      break;
    case PASCAL:
      data = response.json.Items || response.json;
      totalItems = response.json.TotalItems;
      break;
    default:
      throw new Error("Not implemented operation");
  }

  if (data?.some(x => x.id === undefined)) {
    data = data.map((x, i) => ({
      id: x.Id ?? i,
      ...x,
    }));
  }

  return {
    data,
    total: totalItems,
  };
};

export const createResponse = response => {
  const { json } = response;
  let resp = { data: { id: json?.objectId } };
  return resp;
};

export const fetchJson = async ({ url, method, data, params }) => {
  const options = getOptions(method, data, params);

  return fetch(url, options)
    .then(response =>
      response.text().then(text => ({
        status: response.status,
        statusText: response.statusText,
        headers: response.headers,
        body: text,
      })),
    )
    .then(({ status, statusText, headers, body, response }) => {
      let json;
      try {
        json = JSON.parse(body);
      } catch (e) {
        // not json, no big deal
      }
      if (status === 401) {
        return refreshToken({
          callback: () => fetchJson({ url, method, data, params }),
        });
      }

      if (status < 200 || status >= 300) {
        if (json.ErrorCode) {
          let errorResponse;

          if (json?.Properties.length > 0) {
            return Promise.reject(json);
          } else {
            if (errorMessages[json?.ErrorCode]) {
              errorResponse = errorMessages[json.ErrorCode];
            } else {
              if (process.env.NODE_ENV === "development") {
                errorResponse = json.ErrorCode;
              } else {
                errorResponse = errorMessages.default;
              }
            }

            return Promise.reject(new HttpError(errorResponse, status, json));
          }
        }

        return Promise.reject(new HttpError((json && json.message) || statusText, status, json));
      }
      return Promise.resolve({ status, headers, body, json });
    });
};
